export const DomainModelCallbacks = {
	raiseCallback: (opts, callbackType, model) => {
		if (opts !== undefined && opts[callbackType] !== undefined) opts[callbackType](model);
	}
};
